// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import ElementUI from 'element-ui';
import VideoPlayer from 'vue-video-player'
import store from './store'
import NProgress from 'nprogress'
import ajax from '@/util/ajax'

import 'element-ui/lib/theme-chalk/index.css';
import 'nprogress/nprogress.css' 

require('./assets/css/base.css')
require('./assets/css/jquery.lavalamp.css')
require('video.js/dist/video-js.css')
require('vue-video-player/src/custom-theme.css')
require('./assets/js/jquery.lavalamp')

import 'lib-flexible/flexible.js'
import * as filter from './filter/filter'
Object.keys(filter).forEach(key => {
  Vue.filter(key, filter[key])
})

NProgress.inc(0.5)
NProgress.configure({ easing: 'ease', speed: 2000, showSpinner: false })

router.beforeEach((to,from,next) => {
  NProgress.start()
  NProgress.set(0.4)
  NProgress.inc(0.5)
  next()
})

router.afterEach(() => {
  NProgress.done()
})

Vue.prototype.$http = ajax
Vue.use(VideoPlayer)
Vue.use(ElementUI)
Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js